<template>
  <layout-content>
    <package-cards :items="items" />
  </layout-content>
</template>

<script>
  import PackageCards from '@pbx/components/packages/list/cards';
  import { PackageService } from '@pbx/services/PackageService';
  import { DATA } from '@/plugins/vuex-async-pagginate';
  export default {
    components: { PackageCards },

    data() {
      return {
        items: []
      };
    },

    created() {
      PackageService.getDisplayedList()
        .then(res => (this.items = res[DATA]))
        .finally(() => this.endLoadingPage());
    }
  };
</script>
